import { render, staticRenderFns } from "./popup-warning.vue?vue&type=template&id=910fc54a&scoped=true"
import script from "./popup-warning.vue?vue&type=script&lang=ts"
export * from "./popup-warning.vue?vue&type=script&lang=ts"
import style0 from "./popup-warning.vue?vue&type=style&index=0&id=910fc54a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../.eden-mono/temp/node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.11.0_vue-template-compiler@2.7.16_webpack@5.102.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "910fc54a",
  null
  
)

export default component.exports